import { FC } from 'react'
import { useUA } from 'context'
import styled from 'styled-components'
import { ArrowRight } from 'svgIcons'
import Button from '@app.components/Button'
import { ButtonProps } from '@app.components/Button/Button'

interface PredictionButtonProps extends ButtonProps {
  isEndIcon?: boolean
}

const ExamContainedButton: FC<PredictionButtonProps> = ({
  children,
  isEndIcon = true,
  ...props
}) => {
  const { isMobile } = useUA()

  return (
    <StyledWrapper
      isMobile={!!isMobile}
      {...props}
      endIcon={isEndIcon && <ArrowRight className="arrow-icon" />}
    >
      <span>{children}</span>
    </StyledWrapper>
  )
}

export default ExamContainedButton

type TStyledWrapper = {
  isMobile: boolean
}

const StyledWrapper = styled(Button)<TStyledWrapper>`
  display: flex;
  align-items: center;
  width: 100%;
  height: ${({ isMobile }) => (isMobile ? '50px' : '76px')};
  border-radius: 10px;
  gap: 4px;

  background-color: #004eff;

  &:hover {
    background-color: #003ee6;
  }

  .arrow-icon {
    width: ${({ isMobile }) => (isMobile ? '14px' : '18px')};
    height: ${({ isMobile }) => (isMobile ? '14px' : '18px')};
  }

  > span {
    font-size: ${({ isMobile }) => (isMobile ? '16px' : '22px')};
    font-weight: bold;
    line-height: 1.95;
    letter-spacing: -0.88px;
    text-align: center;
  }
`
